import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative size-full',
    image: 'bg-bg-items-white object-contain',
    fullscreenImage: 'fixed inset-0 z-[1000]',
    active:
      'absolute inset-x-0 bottom-0 z-[1000] flex h-13 items-center justify-end bg-black/20 px-4 text-white backdrop-blur-[30px]',
    button: 'heading-xs-intr flex cursor-pointer items-center gap-2',
    buttonText: 'mb-0.5'
  }
});
